import type { CookiePreferences } from './cookieConsent';

type ConsentState = 'granted' | 'denied';

function state(enabled: boolean): ConsentState {
  return enabled ? 'granted' : 'denied';
}

/**
 * GTM reads consent commands from the raw `arguments` object, so a plain array push
 * is not equivalent. index.html already defines this bootstrap; recreate it only if
 * that inline script was stripped (e.g. a prerendered shell served without it).
 */
function ensureGtag() {
  if (typeof window === 'undefined') return null;

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer?.push(arguments as unknown as Record<string, unknown>);
    };
  }

  return window.gtag;
}

/**
 * Mirrors the cookie categories onto Google Consent Mode v2 signals. Until this runs,
 * the defaults declared in index.html keep every non-essential signal denied.
 */
export function updateGoogleConsent(preferences: CookiePreferences) {
  const gtag = ensureGtag();
  if (!gtag) return;

  gtag('consent', 'update', {
    analytics_storage: state(preferences.analytics),
    ad_storage: state(preferences.marketing),
    ad_user_data: state(preferences.marketing),
    ad_personalization: state(preferences.marketing),
    functionality_storage: state(preferences.functional),
    personalization_storage: state(preferences.functional),
    security_storage: 'granted',
  });
}
